import { useState } from "react";
import { MoreHorizontal, Flag } from "lucide-react";
import { cn, Popover, PopoverTrigger, PopoverContent, Button } from "@city-sage/aurum-avis-labs-components";
import { ReportDialog, ReportableType } from "./ReportDialog";

interface ReportButtonProps {
  contentId: string;
  contentType: ReportableType;
  theme?: 'light' | 'dark';
  layout?: 'vertical' | 'horizontal';
  className?: string;
}

export const ReportButton = ({
  contentId,
  contentType,
  theme = 'light',
  layout = 'vertical',
  className
}: ReportButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const isDark = theme === 'dark';
  const isHorizontal = layout === 'horizontal';
  
  const handleReportClick = () => {
    setIsPopoverOpen(false);
    setIsDialogOpen(true);
  };

  return (
    <>
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <PopoverTrigger asChild>
          <button
            className={cn(
              "flex items-center justify-center p-1 bg-transparent border-none cursor-pointer transition-transform active:scale-95 hover:scale-105 group",
              isHorizontal ? "flex-row" : "flex-col",
              className
            )}
            aria-label={`More options for ${contentType}`}
          >
            <MoreHorizontal 
              className={cn(
                "transition-colors duration-200",
                isHorizontal ? "w-5 h-5" : "w-7 h-7",
                isDark 
                  ? "text-white drop-shadow-md group-hover:text-gray-100" 
                  : "text-gray-900 group-hover:text-gray-700"
              )}
              strokeWidth={2}
            />
          </button>
        </PopoverTrigger>
        <PopoverContent 
          className="w-48 p-1" 
          align="end"
          sideOffset={8}
        >
          <Button
            variant="ghost"
            className="w-full justify-start gap-2 text-sm"
            onClick={handleReportClick}
          >
            <Flag className="h-4 w-4" />
            Report
          </Button>
        </PopoverContent>
      </Popover>
      
      <ReportDialog
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        contentId={contentId}
        contentType={contentType}
      />
    </>
  );
};
